<template>
  <v-container fluid>
    <v-card class="academic">
      <v-card-title class="d-flex justify-space-between">
        <v-btn color="error" text @click="$router.back()">
          <v-icon class="mx-2"> arrow_back </v-icon>
          back
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="isValid" ref="academicForm">
          <div><p>Where did you study?</p></div>
          <v-row>
            <v-col cols="12" md="6" sm="12" xs="12">
              <v-text-field
                v-model="formData.institution"
                placeholder="Select Institution"
                label="institution"
                :rules="[rules.required]"
                dense
                persistent-placeholder
                color="primary"
                outlined
                prepend-inner-icon="business"
                clearable
              />
            </v-col>
            <v-col cols="12" md="6" sm="12" xs="12">
              <v-select
                v-model="formData.levels"
                placeholder="Select Education Level"
                label="Education level"
                :items="levels"
                :item-text="(item) => item.description"
                :item-value="(item) => item.code"
                dense
                :rules="[rules.required]"
                color="primary"
                persistent-placeholder
                outlined
                prepend-inner-icon="school"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12" xs="12">
              <v-select
                v-model="formData.certificateAwarded"
                placeholder="Select Certification"
                label="Certification"
                :items="certificationCodes"
                :item-text="(item) => item.description"
                :item-value="(item) => item.code"
                dense
                :rules="[rules.required]"
                color="primary"
                persistent-placeholder
                outlined
                prepend-inner-icon="mdi-account-school"
                clearable
              />
            </v-col>
            <v-col cols="12" md="6" sm="12" xs="12">
              <v-text-field
                v-model="formData.areaOfSpecialization"
                placeholder="Course Title"
                label="Course Title"
                :rules="[rules.required]"
                dense
                persistent-placeholder
                color="primary"
                outlined
                prepend-inner-icon="assignment"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" sm="12" xs="12">
              <v-text-field
                v-model="formData.grade"
                placeholder="Select Grade Attained"
                label="Grade Attained"
                :rules="[rules.required]"
                dense
                @keyup="uppercase"
                color="primary"
                persistent-placeholder
                outlined
                prepend-inner-icon="mdi-medal"
                clearable
              />
            </v-col>
          </v-row>
          <div><p>Attach Certificate</p></div>
          <v-row>
            <v-col cols="12" md="12" sm="12" xs="12">
              <FileUpload
                :Accept="'application/pdf'"
                :IsImage="false"
                :Icon="'cloud_upload'"
                :Outlined="true"
                @updateFile="uploadFile"
                :status="fileStatus"
                :showFile="formData.base64Attachment.length !== 0"
                :base64File="formData.base64Attachment"
                :FileName="
                  academic.lineNo !== undefined
                    ? `${academic.profileID}-${academic.lineNo}`
                    : ''
                "
                :displayOptions="displayOptions"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="submitAcademic"
          class="white--text academic--button mr-4 my-3"
          color="primary"
        >
          <v-icon class="pr-3">
            {{ $route.query.edit !== undefined ? "edit" : "save" }}
          </v-icon>
          {{ $route.query.edit !== undefined ? "SAVE" : "Submit" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
<script>
import FileUpload from "../../../dashboard/components/FileUpload.vue";
import AuthService from "@brainspore/celadon-base/modules/auth/AuthService";
import helpers from "@brainspore/celadon-base/utils/helpers/helper.js";
export default {
  name: "AcademicCard",
  components: { FileUpload },
  data: function () {
    return {
      isValid: false,
      startDate: false,
      endDate: false,
      formData: {
        institution: "",
        levels: "",
        areaOfSpecialization: "",
        certificateAwarded: "",
        qualificationCode: "",
        base64Attachment: "",
      },
      displayOptions: { elevation: "3", width: "60ch", isEdit: true },
      fileStatus: "default",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.query.edit !== undefined) {
        v.$store.dispatch("Profile/getacademics", {
          lineNo: to.query.edit.toString(),
        });
      }
    });
  },
  mounted() {
    Event.$on("backToList", () => {
      this.$router.back();
    });
  },
  watch: {
    academic() {
      this.formData = { ...this.academic };
    },
  },
  computed: {
    academic() {
      return this.$store.getters["Profile/academicsGetters"]("academic");
    },
    type() {
      return ["Educational", "Professional"];
    },
    today() {
      return new Date().toJSON().slice(0, 10);
    },
    levels() {
      return this.$store.getters["Profile/setupGetter"]("levels");
    },
    years() {
      const years = [];
      for (let i = 1900; i <= parseInt(new Date().getFullYear()); i++) {
        years.push(i);
      }
      return years;
    },
    certificationClass() {
      return this.$store.getters["Profile/setupGetter"]("certificationClass");
    },
    certificationCodes() {
      return this.$store.getters["Profile/setupGetter"]("certificationCodes");
    },
    qualificationCodes() {
      return this.$store.getters["Profile/setupGetter"]("qualificationCodes");
    },
  },
  methods: {
    uppercase() {
      this.formData.grade = this.formData.grade.toUpperCase();
    },
    uploadFile: async function (value) {
      if (value.file.name !== undefined) {
        if (value.file.size > 5242880) {
          this.fileStatus = "error";
        } else {
          this.fileStatus = "success";
          this.formData.base64Attachment = await helpers.toBase64(value.file);
          this.formData.base64Attachment =
            this.formData.base64Attachment.split(",")[1];
        }
      } else {
        this.formData.base64Attachment = "";
      }
    },
    submitAcademic() {
      if (!this.isValid) {
        this.$refs.academicForm.validate();
      } else {
        this.formData.profileID = AuthService.user.profile_id;
        this.formData.grade = this.formData.grade.toUpperCase();
        this.$route.query.edit !== undefined
          ? this.$store.dispatch("Profile/editacademics", { ...this.formData })
          : this.$store.dispatch("Profile/submitacademics", {
              ...this.formData,
            });
      }
    },
  },
};
</script>
